import moment, { isMoment } from "moment";

const unixEpoch = "1970-01-01T00:00:00.000000000Z";

export const formatSecondsToHHMM = (value) => {
  if (value) {
    const hours = `${Math.floor(value / 3600)}`.padStart(2, "0");
    const minutes = `${Math.floor(value / 60) % 60}`.padStart(2, "0");
    return `${hours}:${minutes}`;
  }
  return "00:00";
};

export const formatMinutesToHHMM = (value) => {
  if (value) {
    return formatSecondsToHHMM(Math.abs(value) * 60);
  }
  return "00:00";
};
/*Function to compare timeBand values - if it is to the left or to the right on the time slider. E.g: 23:00 should be < than 01:00 */
export const timeBandToInteger = (timeBand) => {
  if (timeBand === "default") return 1000;

  if (!timeBand) return null;

  const absTimeBand = timeBand.replace("-", "");

  if (/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(absTimeBand)) {
    const [hours, minutes] = absTimeBand.split(":");

    const value = (parseInt(hours) * 60 + parseInt(minutes)) / 15;

    return value >= 92 ? value - 96 : value; //if value is > 92 (23:00) the value is for the previous day
  }

  return null;
};

export const offsetDate = (date) => {
  // Moment is not used for getting the offset as UTC is set as the default TZ
  // in root index file in `src/`
  const currentDate = new Date();
  const timezoneOffset = -currentDate.getTimezoneOffset();
  return moment(date).utcOffset(timezoneOffset);
};

export const formatDateToSQLTimestamp = (date) => {
  if (date && isMoment(date)) {
    return date.format("YYYY-MM-DDTHH:mm:ss") + "Z";
  } else {
    return null;
  }
};

export const timestampToHHMM = (timestamp) => {
  if (!timestamp || !moment(timestamp).isValid()) return null;

  return moment(timestamp).format("HH:mm");
};

export const getTimestampFromDate = (date = new Date()) =>
  date.toISOString().replace("Z", "000000Z");

export const getTimestampFromHHMM = (timeString) =>
  unixEpoch.replace(/T(\d{2}):(\d{2})/, `T${timeString}`);

export const isValidTimestamp = (timestamp) =>
  /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}).(\d*)Z/.test(timestamp);

export const isHHMMFormat = (timeString) =>
  /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeString);

export const isMMSSFormat = (timeString) =>
  /^[0-5][0-9]:[0-5][0-9]$/.test(timeString);

export const isTimeGreaterBy = (firstTime, secondTime, diffMinutes) =>
  isHHMMFormat(firstTime) &&
  isHHMMFormat(secondTime) &&
  new Date(getTimestampFromHHMM(firstTime)) <=
    new Date(getTimestampFromHHMM(secondTime)) - diffMinutes * 60 * 1000;

export const getSecondsFromMMSS = (mmss) =>
  (mmss && getDiffInSeconds("00:00", mmss)) || 0;

export const getDiffInSeconds = (a, b) =>
  !isMMSSFormat(a) || !isMMSSFormat(b) || b < a
    ? 0
    : moment.duration(moment(b, "mm:ss").diff(moment(a, "mm:ss"))).asSeconds();

export const getDiffInMinutes = (a, b) =>
  !isHHMMFormat(a) || !isHHMMFormat(b) || b < a
    ? 0
    : moment.duration(moment(b, "HH:mm").diff(moment(a, "HH:mm"))).asMinutes();

export const getDiffInHHMM = (a, b) =>
  !isHHMMFormat(a) || !isHHMMFormat(b) || b < a
    ? ""
    : moment.utc(moment(b, "HH:mm").diff(moment(a, "HH:mm"))).format("HH:mm");

export const getDateFromTimestamp = (timestamp) =>
  isValidTimestamp(timestamp) && moment(timestamp).format("DD/MM/YYYY");

export const formatDateToCorrectTimeZone = (date) =>
  moment(date).tz("Europe/London").format("YYYY-MM-DD");

export const sortWeekdays = (dayA, dayB) => {
  const weekdayOrder = (day) => (day === 0 ? 7 : day);
  return weekdayOrder(dayA) - weekdayOrder(dayB);
};
